import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageSwitcher() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="gap-2"
      title={language === 'de' ? 'Switch to English' : 'Zu Deutsch wechseln'}
    >
      <Globe className="w-4 h-4" />
      <span className="font-medium">{language === 'de' ? 'DE' : 'EN'}</span>
    </Button>
  );
}
